import { render } from "./RegistroReservaciones.vue?vue&type=template&id=1911ef4b&scoped=true"
import script from "./RegistroReservaciones.vue?vue&type=script&lang=js"
export * from "./RegistroReservaciones.vue?vue&type=script&lang=js"

import "./RegistroReservaciones.vue?vue&type=style&index=0&id=1911ef4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1911ef4b"]])

export default __exports__